export const modalConstants = {
    SHOW_MANUAL: 'MODAL_SHOW_MANUAL',
    SHOW_JOKBO: 'MODAL_SHOW_JOKBO',
    SHOW_RESULT: 'MODAL_SHOW_RESULT',
};



// WEBPACK FOOTER //
// ./src/_constants/modal.constants.js